module.exports = __webpack_public_path__ + "static/media/1.5523dedc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/lida/1.JPG
// module id = 536
// module chunks = 0